import React from 'react'
import { Helmet } from 'react-helmet';
import Seo from '../../components/Seo';
import HeaderTwo from '../../components/header/HeaderTwo';
import Footer from '../../components/footer/Footer';
import Breadcrumb from './Breadcrumb';
import BookTwoArea from './BookTwoArea';
import BookTwoRelease from './BookTwoRelease'


function BookTwo() {
  return (
	<>
		<Helmet>
		<link rel="canonical" href="https://oliverandthetimemachine.com/book-two-the-awakening" />
		<title>New Release: Oliver and the Time Machine - Book Two: The Awakening</title>
		<meta name="description" content="New release. The second book in the Oliver and the Time Machine series. In his second thrilling adventure, Oliver returns with AI companion Rosie to face a rapidly evolving threat." />
		<script type="application/ld+json">
			{`
				{
					"@context": "https://schema.org",
					"@type": "Book",
					"name": "Oliver and the Time Machine: The Awakening",
					"author": {
						"@type": "Person",
						"name": "M J Josefsen"
					},
					"isbn": "978-1-7385105-4-2",
					"bookFormat": "Paperback",
					"genre": [
						"Middle Grade",
						"Science Fiction",
						"Time Travel",
						"Middle grade adventure"
					],
					"audience": {
						"@type": "EducationalAudience",
						"educationalRole": "Middle Grade"
					},
					"inLanguage": "English",
					"publisher": "DreamWeave Books"
				}
			`}
		</script>
	</Helmet>
	<Seo 
		title="Oliver and the Time Machine – Book Two: The Awakening"
		description="The second book in the Oliver and the Time Machine series. In his second thrilling adventure, Oliver returns with AI companion Rosie to face a rapidly evolving threat."
		url="/book-two-the-awakening"
		image="/assets/img/newcover-book2.jpg"
	/>
	<HeaderTwo/>
	<main>
	<Breadcrumb/>
	<BookTwoArea/>
	<BookTwoRelease/>
	</main>
	<Footer/>
	</>
  )
}

export default BookTwo